import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  SERVICENEAR_HELP_VIDEO_URL, SERVICENEAR_SUPPORT_CONTACTS, SERVICENEAR_SUPPORT_HOURS, formatSupportPhone
} from '../servicenear-support';

@Component({
  selector: 'app-service-near-contact-us',
  templateUrl: './service-near-contact-us.component.html',
  styleUrls: ['./service-near-contact-us.component.scss']
})
export class ServiceNearContactUsComponent implements OnInit {

  readonly contacts = SERVICENEAR_SUPPORT_CONTACTS;
  readonly supportHours = SERVICENEAR_SUPPORT_HOURS;
  readonly formatPhone = formatSupportPhone;

  constructor(public layoutService: LayoutService) { }

  ngOnInit(): void {
    this.populateToolbarData();
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Contact Us',
    });

    this.layoutService.setNavbarButtons([]);
  }

  callNumber(phone: string) {
    window.location.href = `tel:+${phone}`;
  }

  openWhatsApp(phone: string) {
    window.open(`https://wa.me/${phone}`, '_blank');
  }

  openYoutube() {
    window.open(SERVICENEAR_HELP_VIDEO_URL, '_blank');
  }
}
